import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { EnsureAuth } from '@/pages/_app/ensure-auth'
import { AppLayout } from '@/pages/_app/layout'

export const Route = createFileRoute('/_app')({
  component: RouteComponent,
  validateSearch: (search) =>
    z
      .object({
        registerApplicant: z.boolean().optional(),
      })
      .parse(search),
})

function RouteComponent() {
  return (
    <EnsureAuth>
      <AppLayout />
    </EnsureAuth>
  )
}
